import React from "react";
import DetailsBradcrumeSection from "../Others/DetailsBradcrumeSection";
import { Helmet } from "react-helmet";
import { Link } from "react-router-dom";
import "./AddtoCart.css";
import { useSelector, useDispatch } from "react-redux";
import {
  selectCartItems,
  selectCartTotal,
  removeFromCart,
  updateQuantity,
  // clearCart,
} from "../../ReduxCart/Cart/cartSlice";

export default function AddtoCart() {
  const dispatch = useDispatch();
  const cartItems = useSelector(selectCartItems);
  const cartTotal = useSelector(selectCartTotal);

  const handleRemove = (planid) => {
    dispatch(removeFromCart(planid));
  };

  const handleQuantityChange = (planid, newQuantity) => {
    dispatch(updateQuantity({ planid, quantity: newQuantity }));
  };

  return (
    <>
      <Helmet>
        <meta name="robots" content="noindex, nofollow"></meta>
      </Helmet>

      <DetailsBradcrumeSection
        // Pagename={ServiceDetails.servicetitle}
        Pagename={"Cart"}
        page1={[{ name: "Services", pagelink: "services" }, { name: "cart" }]}
      />

      <section className="cart-section">
        <div className="auto-container">
          <div className="row">
            {cartItems.length === 0 ? (
              <div className="text-center py-4">
                <h2>Your Cart is Empty!</h2>
                <Link to="/services" className="FristBTNhover mt-3">
                  Go to Book Services
                </Link>
              </div>
            ) : (
              <>
                <div className="column col-lg-8 col-md-12 col-sm-12">
                  <div className="cart-outer">
                    <div className="table-outer">
                      <table className="default-table AddtoCartTable">
                        <thead className="cart-header">
                          <tr>
                            <th className="product-name">Plan(Service)</th>
                            <th className="product-price">Price</th>
                            <th className="product-quantity">Quantity</th>
                            <th className="product-subtotal">Subtotal</th>
                            <th className="product-remove">Remove</th>
                          </tr>
                        </thead>
                        <tbody>
                          {cartItems.map((item, index) => (
                            <tr className="cart-item" key={index}>
                              <td className="product-name">
                                <Link to="/">
                                  {item.title}
                                  <br /> (name Chage )
                                </Link>
                              </td>
                              <td className="product-price">
                                ₹{item.selling_price}
                              </td>

                              <td className="product-quantity">
                                <div
                                  className="input-group"
                                  style={{ width: "100px" }}
                                >
                                  <button
                                    className="btnquant quantitydecreaseBTN"
                                    type="button"
                                    onClick={() =>
                                      handleQuantityChange(
                                        item.planid,
                                        item.quantity - 1
                                      )
                                    }
                                  >
                                    <i
                                      className="fa fa-minus"
                                      aria-hidden="true"
                                    ></i>
                                  </button>

                                  <input
                                    type="text"
                                    className="form-control text-center p-0 inputquant qty"
                                    name="quantity"
                                    id="quantity"
                                    style={{ width: "30px" }}
                                    value={item.quantity}
                                    readOnly
                                  />

                                  <button
                                    className=" btnquant quantityincreaseBTN"
                                    type="button"
                                    onClick={() =>
                                      handleQuantityChange(
                                        item.planid,
                                        item.quantity + 1
                                      )
                                    }
                                  >
                                    <i
                                      className="fa fa-plus"
                                      aria-hidden="true"
                                    ></i>
                                  </button>
                                </div>
                              </td>
                              <td className="product-subtotal">
                                <span className="amount">
                                  ₹
                                  {(item.selling_price * item.quantity).toFixed(
                                    2
                                  )}
                                </span>
                              </td>
                              <td className="product-remove">
                                {" "}
                                <button
                                  onClick={() => handleRemove(item.planid)}
                                  className="remove"
                                >
                                  <span className="text-danger">
                                    <i
                                      className="fa fa-trash-o"
                                      aria-hidden="true"
                                    ></i>
                                  </span>
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                </div>

                <div className="column col-lg-4 col-md-12 col-sm-12">
                  <div className="totals-table-outer">
                    <ul className="totals-table">
                      <li>
                        <h3>Cart Totals</h3>
                      </li>
                      <li>
                        <span className="col">Subtotal</span>
                        <span className="col price">
                          ₹{cartTotal.toFixed(2)}
                        </span>
                      </li>
                      <li>
                        <span className="col">Total</span>
                        <span className="col price">
                          ₹{cartTotal.toFixed(2)}
                        </span>
                      </li>
                    </ul>
                    <Link
                      to="/checkout-demo"
                      className={`theme-btn btn-style-one proceed-btn ${
                        cartItems.length === 0 ? "disabled" : ""
                      }`}
                    >
                      Proceed to Checkout
                    </Link>
                    {/* {cartItems.length > 0 && (
                      <button
                        onClick={() => dispatch(clearCart())}
                        className="FristBTNhover"
                      >
                        Clear Cart
                      </button>
                    )} */}
                  </div>
                </div>
              </>
            )}
          </div>
        </div>
      </section>
    </>
  );
}
